import type { User } from '@/types/user';
import { useContractGateStore } from '@/shared/stores/contract-gate-store';

import { hasSignedCreatorContract } from './permissions';

/**
 * First-login auto-trigger for the Creator Agreement dialog.
 *
 * BE emits `last_login: null` on the first authenticated session (via
 * `CompleteUserSession`). When that lines up with a creator who has not yet
 * signed the agreement, force the dialog open so they accept (or dismiss with
 * the confirm-close prompt) before continuing.
 *
 * Subsequent logins receive an ISO timestamp — gate stays dormant.
 */
export function triggerContractGateOnFirstLogin(payload: {
  last_login: string | null | undefined;
  user: User | null | undefined;
}): void {
  if (!payload.user) return;
  // `null` = first login; `undefined` = BE didn't emit (treat as not first).
  if (payload.last_login !== null) return;
  if (!payload.user.is_creator) return;
  if (hasSignedCreatorContract(payload.user)) return;
  useContractGateStore.getState().open(undefined, 'first_login');
}
